import React from 'react';
import CollapsiblePanel from "../../base/CollapsiblePanel";
import QuestionGroups from "./QuestionGroups";
import { Row, Col, FormGroup, FormControl, ControlLabel } from 'react-bootstrap';
import { translate } from "../../base/Translation";
//import { connect } from "react-redux";

class QuestionSection extends React.Component {

	removeSection(evt) {
		//eslint-disable-next-line
		if (confirm(translate("Ste si istý?")) === false) return;
		this.props.updateSection(this.props.section, true);
	}

	onChange(evt) {
		let section = this.props.section;
		section[evt.target.name] = evt.target.value;
		this.props.updateSection(section, false);
	}

	render() {
		return (
			<CollapsiblePanel title={this.props.section.name ? this.props.section.name : "---"}
				expanded={this.props.section.id < 1} key={this.props.section.id} footer={() => {
					return (
						<div className="text-right">
							<button className="btn btn-danger btn-xs" onClick={this.removeSection.bind(this)}>
								{translate("Odstrániť sekciu")}
							</button>
						</div>
					)
				}}>
				<Row>
					<Col lg={4} sm={12}>
						<FormGroup className="form-group-sm">
							<ControlLabel>{translate("Názov")}</ControlLabel>
							<FormControl defaultValue={this.props.section.name} onBlur={this.onChange.bind(this)}
								name="name" />
						</FormGroup>
					</Col>
					<Col lg={4} sm={12}>
						<FormGroup>
							<ControlLabel>{translate("Bodová váha")}</ControlLabel>
							<FormControl type="number" defaultValue={this.props.section.weight} onBlur={this.onChange.bind(this)}
								name="weight" />
						</FormGroup>
					</Col>
					<Col lg={4} sm={12}>
						<FormGroup>
							<ControlLabel>{translate("Poznámka")}</ControlLabel>
							<FormControl defaultValue={this.props.section.note} onBlur={this.onChange.bind(this)}
								name="note" />
						</FormGroup>
					</Col>
					<Col lg={12}>
						<QuestionGroups
							groups={this.props.section.question_groups}
							section={this.props.section.id} />
					</Col>
				</Row>
			</CollapsiblePanel>
		)
	}
}

//export default connect(state => ({ form: state.form }))(QuestionSection);
export default QuestionSection;


// WEBPACK FOOTER //
// ./src/modules/form/edit/QuestionSection.js